import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Title = styled.h3`
  display: ${props => props.theme.display || 'block'};
  align-items: flex-end;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  border-radius: ${props => props.theme.borderRadius.default};
  border-bottom: ${props => props.theme.borderColor || 'none'};
  color: ${props => props.titleColor || props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${props =>
    props.theme.isBackground &&
    css`
      background: ${props => props.titleBackground || props.theme.background};
    `}

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-gap: ${props => props.theme.gridGap.default};

  ${Media.md`
    grid-gap: ${props => props.theme.gridGap.md};
  `}
`;

export const Image = styled.img`
  display: block;
  max-height: 65px;
  margin-right: 24px;
  margin-left: 6px;
  object-fit: contain;
`;
